import React from "react";
import ReactDOM from 'react-dom/client';
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import "./i18n";
import { Provider } from "react-redux";
import { GoogleOAuthProvider } from "@react-oauth/google"
const config = require("config")
import { PostHogProvider} from 'posthog-js/react'

import store from "./store";

// preventMousewheel.js
function preventMousewheel(e) {
  if (e.target.type === 'number') {
    e.target.blur();
  }
}

window.preventMousewheel = preventMousewheel;

const options = {
  api_host: config.posthog.REACT_APP_PUBLIC_POSTHOG_HOST,
}



const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Provider store={store}>
        <GoogleOAuthProvider clientId={config.google_sso.CLIENT_ID}>
          <React.Fragment>
            <PostHogProvider
              apiKey={config.posthog.REACT_APP_PUBLIC_POSTHOG_API_KEY}
              options={options}>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </PostHogProvider>
          </React.Fragment>
        </GoogleOAuthProvider>
    </Provider>
);

serviceWorker.unregister()
